import Button from 'src/components/design-system/Button';
import {
  CanImportMultipleCompanies,
  CanImportSingleCompany,
} from 'src/components/guards/PermissionsList';
import usePeriodView from 'src/hooks/usePeriodView';
import usePermission from 'src/hooks/usePermissions';
import ImportSidePanel from './ImportExport/ImportSidePanel';

const ImportExport = () => {
  const { t, importExportPanelOpen } = usePeriodView();
  const isImportable = usePermission({
    permissions: [...CanImportMultipleCompanies, ...CanImportSingleCompany],
    or: true,
  });

  return (
    <>
      <Button color="secondary" onClick={importExportPanelOpen}>
        {t(isImportable ? 'Import/Export' : 'Export')}
      </Button>
      <ImportSidePanel isImportable={isImportable} />
    </>
  );
};
export default ImportExport;
